import { createFeatureSelector, createSelector } from '@ngrx/store'
import * as reducer from './expense.reducer'
import * as state from './expense.state'
import * as R from 'ramda'
import { categories } from './expense.constants'
import { getItemCategoryOptions } from '../../functions'

export const expenseState = createFeatureSelector<state.State>('expense')

export const selectAllExpenses = createSelector(expenseState, reducer.selectAll)
export const selectExpenseEntities = createSelector(expenseState, reducer.selectEntities)

export const selectExpensesLoaded = createSelector(expenseState, (state: state.State) => state.isLoaded)
export const selectExpenseSettingsLoaded = createSelector(expenseState, (state: state.State) => state.isSettingsLoaded)

export const selectExpenseById = (id: string) => createSelector(selectExpenseEntities, (data) => data[id])

export const selectExpenseSettings = createSelector(expenseState, (s) => s.settings)
export const selectExpenseUserApproveItem = (userId: string) =>
  createSelector(selectExpenseSettings, (settings) => {
    return R.find((t) => t.user_id === userId, settings?.approvers || [])
  })

export const selectAllExpenseCategories = createSelector(selectAllExpenses, (expenses) => {
  return getItemCategoryOptions(expenses, categories)
})
